<template>
  <div class="" v-show="tabledata">
    <div class="table-responsive desk inside-box" ref="tableContainer" v-if="isDesktop">
      <table class="table vtable">
        <thead>
          <tr>
            <th v-show="!column.hide" :class="column.align" :width="column.width" v-for="(column, index) in tabledata.columns" v-html="column.name" :key="index"></th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in tabledata.items">
            <tr @click="selectRow(item,  $event)" :class="`tr_${item.id}`">
              <td :class="[column.align, column.type != undefined ? `${column.type}-line` : '']"
                v-for="(column, indexColumn) in tabledata.columns" :key="indexColumn">
                {{tabledata.totalCount}}
                <slot v-if="column.key == 'name'" :name="`column_${column.key}`" :item="item"/>
                <slot v-if="column.type == 'custom'" :name="`column_${column.key}`" :item="item"/>
                <span v-if="column.type == 'date'">{{ formatDate(item, column.value) }}</span>
                <span v-if="column.type == undefined || column.type == 'string' && column.key != 'name'" v-html="getValue(item, column.value)"></span>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <div class="vtable-mob mob inside-box-mob" ref="tableResponsiveContainer" v-else>
      <ul class="">
        <template v-for="(item, index) in tabledata.items">
          <li class="inside-box-mob-item" :class="`tr_${item.id}`" @click="selectRow(item, $event)">
            <p :class="`${column.type}-line`" v-for="(column, indexColumn) in tabledata.columns" :key="indexColumn">
              <slot v-if="column.key == 'name'" :name="`column_${column.key}`" :item="item"/>
              <slot v-if="column.type == 'custom'" :name="`column_${column.key}`" :item="item"/>
              <slot v-if="column.type == 'date'" :item="item" @click="selectRow(item, $event)">{{ formatDate(item, column.value) }}</slot>
              <slot v-if="column.type == undefined || column.type == 'string' && !column.key" :item="item">{{ getValue(item, column.value) }}</slot>
              <!-- <span v-if="column.type == undefined || column.type == 'string' && column.key != 'name'" v-html="getValue(item, column.value)"></span> -->
            </p>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .scrollbar {
    overflow-y:                     auto;
  }

  .mob {
    display:                        none;
  }

  .btn-load {
    color:                          var(--Brand-Primary);
    display:                        block;
    margin:                         0 auto;
    padding:                        10px 20px;
    background:                     var(--Shades-BG);
    border:                         1px solid var(--Shades-30-Border);
  }

  .vtable-mob:not(.inside-box-mob) {
    ul {
      margin:                       0.5em 0;
      li {
        p {
          display:                  block;
          margin-bottom:            10px;
          // span:last-child:not(:first-child) {
          span:not(:first-child), button {
            float:                  right;
          }
        }
      }
    }
  }

  @media (max-width: 991px) {
    .desk {
      display:                      none;
    }
    .mob {
      display:                      block;
    }
    .vtable-mob .label {
      line-height:                  1.4;
    }
    .eyerweb {
      .vtable-mob {
        > ul > li p {
          &:first-child {
            margin-bottom:          25px;
          }
        }
      }
    }
  }
</style>

<script>
import { useExamFilterStore } from '@/store/examFilter'

export default {
  name: 'BaseTable',
  props: ['tabledata'],
  data: () => ({
    dateFormat: "",
    isDesktop: true,
  }),
  watch: {
    'tabledata.items'(newItems, oldItems) {
      const tableContainer = this.isDesktop ? this.$refs.tableContainer : this.$refs.tableResponsiveContainer;
      tableContainer.scrollTop = 0;
    }
  },
  computed: {
    isExamRoute() {
      return this.$router.currentRoute._value.name == 'exam-list'
    }
  },
  mounted() {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    })

    this.dateFormat = this.$i18n.t('dateTimeFormat')

    this.updateIsDesktop()
    window.addEventListener('resize', this.updateIsDesktop)
  },
  methods: {
    getValue(data, key) {
      return _.get(data, key)
    },
    formatDate(data, key) {
      let value = _.get(data, key)
      let result = moment(value).format(this.dateFormat)
      return result
    },
    selectRow(item, event) {
      let isCommandPressed = event.ctrlKey || (event.button === 1)

      this.$emit('item-opened',  {item: item, commandPressed: isCommandPressed})
    },
    updateIsDesktop() {
      this.isDesktop = window.innerWidth > 991;
    },
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateIsDesktop);
  }
}
</script>
